export default "__VITE_ASSET__CGq$MLYm__"